<template>
  <el-dialog title="Confirmação de pagamento" center :visible.sync="dialog" v-loading="loading" class="center"
    style="text-align: center">
    <el-result v-if="status" :icon="icon" :title="title"></el-result>
    <PaymentFinishedPix v-else-if="type === 'pix'" :value="value" :customer="customer" @payment="finish" ref="pix" :billetId="billetId"/>
    <PaymentFinishedCard v-else-if="type === 'credit' || type === 'debit'" :value="value" :token="token" ref="credit"
      :customer="customer" @payment="finish" :billetId="billetId" />

    <span slot="footer" class="dialog-footer">
      <el-button @click.stop.prevent="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PaymentFinishedPix from './PaymentFinishedPix.vue';
import PaymentFinishedCard from './PaymentFinishedCard.vue';

export default {
  name: 'PaymentFinished',
  props: {
    value: Number,
    customer: String,
    type: String,
    token: String,
    billetId: String,
  },
  watch: {
    token(newVaue, oldValue) {
      console.log('payment watch token', newVaue, oldValue);
      this.status = '';
    },
  },
  computed: {
    icon() {
      return this.status === 'paid' ? 'success' : 'error';
    },
    title() {
      return this.status === 'paid'
        ? 'Pagamento realizado com sucesso'
        : this.status === 'not_authorized'
          ? 'Pagamento não autorizado'
          : 'Erro no realizar o pagamento';
    }
  },
  data() {
    return {
      dialog: false,
      loading: true,
      status: '',
    };
  },
  mounted() {
    const vm = this;
    vm.$bus.$on("payment.done", (data) => {
      if (data === 'order.paid') vm.finish('paid', true);
      else vm.finish('not_authorized', false);
    });
  },
  methods: {
    updated() {
      console.log('updated')
      this.status = '';
    },
    finish(status, success) {
      console.log('finish(', status)
      this.status = success ? 'paid' : status;
      if (success) this.$emit('redirect')
      else if (status === 'not_authorized') this.$emit('first');
    },
    open() {
      console.log('open', this.$options);
      this.dialog = true;
      console.log(this.$refs, this.type)
      setTimeout(() => {
        if (this.$refs[this.type]) this.$refs[this.type].open();
      }, 200)
    },
  },
  components: { PaymentFinishedPix, PaymentFinishedCard }
}
</script>
